import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';
import { IHeatmapPayload, ISummaryPayload } from './models';

// choose survey actions
export const getSurveyRoundList = createApiAction(types.GET_SURVEY_ROUND_LIST);
export const getEmployeeList = createApiAction(types.GET_EMPLOYEE_LIST);
export const resetEmployeeList = createAction(types.RESET_EMPLOYEE_LIST);
export const getShortClientList = createApiAction(types.GET_SHORT_CLIENT_LIST);
export const updateDashboardClientList = createApiAction(
	types.UPDATE_DASHBOARD_CLIENT_LIST,
);

// comment actions
export const getComment = createApiAction(types.GET_COMMENT);
export const getCommentAverage = createApiAction(types.GET_COMMENT_AVERAGE);
export const getMarksForEmployer = createApiAction(
	types.GET_MARKS_FOR_EMPLOYER,
);
export const resetMarksForEmployer = createAction(
	types.RESET_MARKS_FOR_EMPLOYER,
);
export const getRelatedComments = createApiAction(
	types.GET_ALL_RELATED_COMMENTS,
);
export const getCompareComments = createApiAction(types.GET_COMPARE_COMMENTS);
export const resetCommentsList = createAction(types.RESET_COMMENT_LIST);
export const setActiveCommentCommentsType = createAction(
	types.SET_COMMENTS_COMMENT_TYPE,
);
export const resetActiveCommentsType = createAction(types.RESET_COMMENTS_TYPE);
export const resetComparedComments = createAction(
	types.RESET_COMPARED_COMMENTS,
);

// dashboard actions
export const getDashboardComments = createApiAction(
	types.GET_DASHBOARD_COMMENTS,
);
export const getDashboardCommentsWordcloud = createApiAction(
	types.GET_DASHBOARD_COMMENTS_WORDCLOUD,
);
export const setActiveDashboardCommentType = createAction(
	types.SET_ACTIVE_DASHBOARD_COMMENT_TYPE,
);
export const getSurveyResults = createApiAction(types.GET_SURVEY_RESULTS);
export const getDashboardContent = createApiAction(types.GET_DASHBOARD_CONTENT);
export const getRoundsList = createApiAction(types.GET_DASHBOARD_ROUNDS_LIST);
export const setActiveRound = createAction(types.SET_DASHBOARD_ACTIVE_ROUND);
export const getRoundData = createApiAction(types.GET_DASHBOARD_ROUND_DATA);
export const getServicesList = createApiAction(
	types.GET_DASHBOARD_SERVICES_LIST,
);
export const setActiveService = createAction(
	types.SET_DASHBOARD_ACTIVE_SERVICE,
);
export const getRolesList = createApiAction(types.GET_DASHBOARD_ROLES_LIST);
export const setActiveRole = createAction(types.SET_DASHBOARD_ACTIVE_ROLE);
export const getBusinessUnitList = createApiAction(
	types.GET_DASHBOARD_BUSINESS_UNIT_LIST,
);
export const setActiveBusinessUnit = createAction(
	types.SET_DASHBOARD_ACTIVE_BUSINESS_UNIT,
);
export const getTrendsList = createApiAction(types.GET_DASHBOARD_TRENDS_LIST);
export const getCompareTrendsList = createApiAction(
	types.GET_DASHBOARD_COMPARE_TRENDS_LIST,
);
export const getDashboardServicesCards = createApiAction(
	types.GET_DASHBOARD_SERVICE_CARDS,
);
export const getMapData = createApiAction(types.GET_DASHBOARD_MAP_DATA);
export const getDashboardRegions = createApiAction(types.GET_DASHBOARD_REGIONS);
export const setActiveLocation = createAction(
	types.SET_DASHBOARD_ACTIVE_LOCATION,
);
export const getDashboardReport = createApiAction(types.GET_DASHBOARD_REPORT);
export const resetDashboardData = createAction(types.RESET_DASHBOARD_DATA);
export const resetShouldResetRegion = createAction(
	types.RESET_FILTERS_TO_RESET,
);

export const getStatistic = createApiAction(types.GET_STATISTIC);
export const getServiceStats = createApiAction(types.GET_SERVICE_STATS);

// Comments page
export const getCommentsData = createApiAction(types.GET_ALL_COMMENTS_DATA);
export const getRangeData = createApiAction(types.GET_RANGE_DATA);
export const getRounds = createApiAction(types.GET_ROUNDS);

// persona action
export const getPersonaList = createApiAction(types.GET_PERSONA_LIST);
export const getPersonaDetails = createApiAction(types.GET_PERSONA_DETAILS);
export const resetPersonaDetails = createAction(types.RESET_PERSONA_DETAILS);
export const getPersonaTrends = createApiAction(types.GET_PERSONA_TRENDS);
export const getPersonaTypicalRoles = createApiAction(
	types.GET_PERSONA_TYPICAL_ROLES,
);
export const getPersonaSatisfaction = createApiAction(
	types.GET_PERSONA_SATISFACTION,
);
export const getPersonaComments = createApiAction(types.GET_PERSONA_COMMENTS);
export const getPersonaCommentsWordcloud = createApiAction(
	types.GET_PERSONA_COMMENTS_WORDCLOUD,
);
export const setActiveCommentType = createAction(
	types.SET_PERSONA_ACTIVE_COMMENT_TYPE,
);

export const setActiveServiceExamples = createAction(
	types.SET_ACTIVE_SERVICE_EXAMPLES,
);

// actions for quick surveys
export const getNpsTrends = createApiAction(types.GET_NPS_TRENDS);
export const getQuickQuestionAnswers = createApiAction(
	types.GET_QUICK_QUESTION_ANSWERS,
);
export const setActiveDashboardAnswersType = createAction(
	types.SET_ACTIVE_DASHBOARD_ANSWERS_TYPE,
);
export const getQuickQuestionAnswersWordcloud = createApiAction(
	types.GET_QUICK_QUESTION_ANSWERS_WORDCLOUD,
);

// EXECUTIVE SUMMARY PAGE
export const getAllSummaryData = createApiAction<ISummaryPayload>(
	types.GET_ALL_SUMMARY_DATA,
);
export const getSummaryRounds = createApiAction<ISummaryPayload>(
	types.GET_SUMMARY_ROUNDS,
);
export const getSummaryServiceCards = createApiAction<ISummaryPayload>(
	types.GET_SUMMARY_SERVICE_CARDS,
);
export const getSummaryHeatmapStatistic = createApiAction<IHeatmapPayload>(
	types.GET_SUMMARY_HEATMAP_STATISTIC,
);
export const getSummaryServiceList = createApiAction<{ surveyRoundId: string }>(
	types.GET_SUMMARY_SERVICE_LIST,
);
export const getClientLogo = createApiAction<{ surveyRoundId: string }>(
	types.GET_CLIENT_LOGO,
);
export const getSummaryMetrics = createApiAction<{ surveyRoundId: string }>(
	types.GET_SUMMARY_METRICS,
);
export const resetErrors = createAction(types.RESET_ERRORS);
